export default __webpack_public_path__ + "static/media/injection.6ace2515.png";